/* @flow */

'use strict';

var getStateKey = require('./get-state-key');

var getState = function getState(state /*: {_radiumStyleState: {[key: string]: {[value: string]: boolean}}}*/, elementKey /*: string*/, value /*: string*/) /*: any*/ {
  var key = getStateKey(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

module.exports = getState;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/get-state.js
// module id = 718
// module chunks = 0